var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlankDataPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.202,
    height: 146.744,
    viewBox: "0 0 151.202 146.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45091",
    "data-name": "Group 45091",
    transform: "translate(-980.009 -371.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76033",
    "data-name": "Path 76033",
    d: "M150.5,117.019,39.846,131.977a2.945,2.945,0,0,1-3.314-2.524L21.574,18.8A2.945,2.945,0,0,1,24.1,15.486L134.751.526a2.947,2.947,0,0,1,3.314,2.526l14.957,110.653a2.944,2.944,0,0,1-2.524,3.314",
    transform: "translate(959.465 372.292)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76034",
    "data-name": "Path 76034",
    d: "M150.5,117.019,39.846,131.977a2.945,2.945,0,0,1-3.314-2.524L21.574,18.8A2.945,2.945,0,0,1,24.1,15.486L134.751.526a2.947,2.947,0,0,1,3.314,2.526l14.957,110.653A2.944,2.944,0,0,1,150.5,117.019Z",
    transform: "translate(959.465 372.292)",
    fill: "none",
    stroke: "#37509e",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76035",
    "data-name": "Path 76035",
    d: "M145.486,112.766l-105.034,14.2a2.945,2.945,0,0,1-3.314-2.524L22.937,19.4a2.948,2.948,0,0,1,2.526-3.314L130.5,1.891a2.947,2.947,0,0,1,3.314,2.526l14.2,105.034a2.944,2.944,0,0,1-2.524,3.314",
    transform: "translate(961.287 374.117)",
    fill: "#aec9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76036",
    "data-name": "Path 76036",
    d: "M146.132,133.821,34.727,126.309a2.946,2.946,0,0,1-2.741-3.139L39.5,11.765a2.945,2.945,0,0,1,3.136-2.741l111.407,7.511a2.948,2.948,0,0,1,2.741,3.139l-7.511,111.405a2.946,2.946,0,0,1-3.139,2.741",
    transform: "translate(973.413 383.681)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76037",
    "data-name": "Path 76037",
    d: "M146.132,133.821,34.727,126.309a2.946,2.946,0,0,1-2.741-3.139L39.5,11.765a2.945,2.945,0,0,1,3.136-2.741l111.407,7.511a2.948,2.948,0,0,1,2.741,3.139l-7.511,111.405A2.946,2.946,0,0,1,146.132,133.821Z",
    transform: "translate(973.413 383.681)",
    fill: "none",
    stroke: "#37509e",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76038",
    "data-name": "Path 76038",
    d: "M130.533,102.3,40.37,96.216a2.949,2.949,0,0,1-2.741-3.139l5.179-76.811a2.946,2.946,0,0,1,3.139-2.741L136.11,19.6a2.949,2.949,0,0,1,2.741,3.139l-5.179,76.811a2.946,2.946,0,0,1-3.139,2.741",
    transform: "translate(980.959 389.699)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76039",
    "data-name": "Path 76039",
    d: "M130.533,102.3,40.37,96.216a2.949,2.949,0,0,1-2.741-3.139l5.179-76.811a2.946,2.946,0,0,1,3.139-2.741L136.11,19.6a2.949,2.949,0,0,1,2.741,3.139l-5.179,76.811A2.946,2.946,0,0,1,130.533,102.3Z",
    transform: "translate(980.959 389.699)",
    fill: "none",
    stroke: "#37509e",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76040",
    "data-name": "Path 76040",
    d: "M63.076,30.209a9.621,9.621,0,1,1-8.953-10.248,9.622,9.622,0,0,1,8.953,10.248",
    transform: "translate(989.292 398.284)",
    fill: "#aec9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76041",
    "data-name": "Path 76041",
    d: "M62.357,29.2A9.621,9.621,0,1,1,53.4,18.954,9.622,9.622,0,0,1,62.357,29.2Z",
    transform: "translate(988.331 396.937)",
    fill: "none",
    stroke: "#37509e",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76042",
    "data-name": "Path 76042",
    d: "M122.025,62.977a1.108,1.108,0,0,0-.122-.587L105.093,30.365a2.691,2.691,0,0,0-4.162-.795L79.677,48.139a3.784,3.784,0,0,1-5.338-.36l-6.845-7.836a3.787,3.787,0,0,0-5.389-.316L43.052,56.865a1.087,1.087,0,0,0-.358.736l-.68,10.106a1.089,1.089,0,0,0,1.014,1.162l77.106,5.2a1.092,1.092,0,0,0,1.162-1.012Z",
    transform: "translate(986.828 410.273)",
    fill: "#aec9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76043",
    "data-name": "Path 76043",
    d: "M41.633,56.1l20.2-18.281a2.694,2.694,0,0,1,3.833.224l8.294,9.5a2.69,2.69,0,0,0,3.8.255L99.839,28.508A2.69,2.69,0,0,1,104,29.3l16.673,32.339",
    transform: "translate(986.321 408.853)",
    fill: "none",
    stroke: "#37509e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankDataPlaceholder);
export default __webpack_public_path__ + "static/media/blank-data-placeholder.49e5769fbd4dea35040e73a9d4373c3f.svg";
export { ForwardRef as ReactComponent };